<ng-container *ngIf="justinoActive">
  <div
    class="corner-gif-container"
    (mouseover)="showBubble = true; handleMouseOver()"
    (mouseleave)="showBubble = false">
    <img
      id="cornerGif"
      src="assets/gif/Giff_Justino.gif"
      alt="Justino"
      class="corner-gif"
      (click)="redirectToPage()" />
    <div class="message-bubble" *ngIf="showBubble">
      Buenos días. Estoy a su disposición para asistirle en el diligenciamiento
      de formularios o para responder cualquier inquietud que pueda tener. Puede
      hacer clic para continuar.
    </div>
  </div>
</ng-container>
